/*
  ['Publication settings', '/publications', pubScope('publication_settings.list'), false],
  Returns an object with link data, formatted for the Nav component
*/
import { get } from '../../../utils/shared/api';

const secondaryLinksArray = (linkManager, cashoutBalance) => {
  const links = [
    {
      ...linkManager.build('Messages'),
      icon: 'messages',
      noticeRequest: () =>
        get('/messages/unread_message_count', false).then(
          response => !!response.unread_message_count
        )
    }
  ];

  cashoutBalance !== '$0' && links.unshift({ name: cashoutBalance, path: '/account/activity' });

  return links;
};

export default (linkManager, onIaVersionChange, cashoutBalance) => ({
  primaryLinks: [
    linkManager.build('Tasks'),
    // linkManager.build('Tasks (beta)'),
    linkManager.build('Calendar'),
    linkManager.build('Campaigns'),
    linkManager.build('Drafts'),
    linkManager.build('Ideation'),
    linkManager.build('Stories'),
    linkManager.build('Media'),
    linkManager.build('Analytics'),
    linkManager.build('Talent'),
    linkManager.build('Portfolio')
  ],
  createLinks: [
    [
      linkManager.build('Story'),
      linkManager.build('Recurring story'),
      linkManager.build('Upload story')
    ],
    [linkManager.build('Pitch'), linkManager.build('Pitch request')],
    [linkManager.build('Event')],
    [linkManager.build('User')],
    [linkManager.build('Campaign')],
    [linkManager.build('Talent search')],
    [linkManager.build('Draft')]
  ],
  secondaryLinks: secondaryLinksArray(linkManager, cashoutBalance),
  userLinks: [
    linkManager.build('Your account'),
    linkManager.build('Command center'),
    {
      name: 'Help center',
      path: 'https://support.contently.com/'
    },
    linkManager.build('Financial activity'),
    [linkManager.build('Publication settings')],
    [linkManager.build('Switch to Nav V2', () => onIaVersionChange('V2'))],
    [linkManager.build('Sign out')]
  ]
});



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/ia_map_v1.js